module.exports = __webpack_public_path__ + "img/worldwide.2882a795.png";